import { getURLParams } from './getURLParams';

export default function getSsoGrayTag() {
  let clientId = '';
  try {
    clientId = getURLParams(window.location.href, 'clientId') || '';
    if (!clientId) {
      clientId = getURLParams(window.location.href, 'client_id') || '';
    }
    if (!clientId) {
      clientId = getURLParams(window.location.href, 'ssoGrayTag') || '';
    }
  } catch (error) {
    console.error('获取url上clientId报错', error);
  }
  return clientId;
}
